// extracted by mini-css-extract-plugin
module.exports = {"contentGrid":"SaMCNewLeadsUploaderPage_contentGrid__3nv4s"};